export const CocoCelebrationAssets = [
  {
    type: 'winter',
    mascotPath: '/assets/coco-celebrations/winter/mascot.svg',
    avatarPath: '/assets/coco-celebrations/winter/avatar.svg',
    globalAnimation: 'snow'
  },
  {
    type: 'halloween',
    mascotPath: '/assets/coco-celebrations/halloween/mascot.svg',
    avatarPath: '/assets/coco-celebrations/halloween/avatar.png',
    globalAnimation: 'bat'
  },
  {
    type: 'default',
    mascotPath: '/assets/coco-celebrations/default/mascot.svg',
    avatarPath: '/assets/coco-celebrations/default/avatar.png',
    globalAnimation: null
  }
];
